<template>
    <b-tab title-link-class="p-0">
        <template v-slot:title>
            <b-nav-item-dropdown no-flip name="tab-invoices">
                <template slot="button-content">
                    <i class="cus-page-white-stack"></i>
                    Invoices
                </template>
                <div>
                    <b-dropdown-item
                        @click="displayList(INVOICE_LIST_STATUS.ALL)"
                    >
                        <i class="cus-page-white-stack"></i>
                        View All Invoices
                    </b-dropdown-item>

                    <b-dropdown-item
                        @click="displayList(INVOICE_LIST_STATUS.OPEN)"
                    >
                        <i class="cus-page-white-error"></i>
                        View Open Invoices
                    </b-dropdown-item>

                    <b-dropdown-item
                        @click="displayList(INVOICE_LIST_STATUS.LOCKED)"
                    >
                        <i class="cus-page-white-key"></i>
                        View Locked Invoices
                    </b-dropdown-item>
                    <b-dropdown-item
                        @click="displayList(INVOICE_LIST_STATUS.UNPAID)"
                    >
                        <i class="cus-page-white-error"></i>
                        View Unpaid Invoices
                    </b-dropdown-item>
                    <b-dropdown-item
                        @click="displayList(INVOICE_LIST_STATUS.REOPENED)"
                    >
                        <i class="cus-page-white-error"></i>
                        View Reopened Invoices
                    </b-dropdown-item>
                    <b-dropdown-item
                        @click="displayList(INVOICE_LIST_STATUS.PAID)"
                    >
                        <i class="cus-folder-page-white"></i>
                        View Paid Invoices
                    </b-dropdown-item>
                </div>

                <li
                    v-if="_hasAccess('billing.invoice.create')"
                    class="dropdown-divider"
                ></li>

                <b-dropdown-item
                    v-if="_hasAccess('billing.invoice.create')"
                    @click="openInvoicesModal"
                >
                    <i class="cus-add"></i>
                    New Invoice
                </b-dropdown-item>
            </b-nav-item-dropdown>
        </template>
        <b-card-text>
            <invoice-list
                ref="invoiceList"
                :key="keyview"
                :status="status"
                @redirect-other-tab="redirectOtherTab"
            />
        </b-card-text>
    </b-tab>
</template>

<script>
import InvoiceList from "@/components/billing-invoice/invoices-list";

const INVOICE_LIST_STATUS = {
    ALL: 3,
    OPEN: 7,
    UNPAID: 1,
    PAID: 2,
    LOCKED: 5,
    REOPENED: 6
};

export default {
    components: {
        InvoiceList
    },
    data() {
        return {
            INVOICE_LIST_STATUS,
            keyview: 0,
            status: 1
        };
    },
    methods: {
        displayList(status) {
            this.keyview += 1;
            this.status = status;
        },
        reloadEstimate() {
            // Render getInvoices when the invoiceList already rendered
            if (this.$refs.invoiceList) {
                this.$refs.invoiceList.getInvoices();
            }
        },
        openInvoicesModal() {
            this.$emit("open-new-invoice");
        },
        redirectOtherTab(tab) {
            this.$emit("redirect-other-tab", tab);
        }
    }
};
</script>
